import { Outlet } from "react-router-dom";

function OurTeamLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default OurTeamLayout;
